export const azureB2c = {
  ERROR_CODE_FORGOTTON_PASSWORD: "AADB2C90118",
  CANCELLED_ERROR_CODE: "AADB2C90091",
  ID_TOKEN_CLAIM: "B2C_1_chas_reset",
  ACCESS_TOKEN_KEY: "b2c.access.token"
}
